import { Button, Col, Divider, Form, Input, message, Modal, Row, Spin } from "antd";
import FormItem from "antd/lib/form/FormItem";
import TextArea from "antd/lib/input/TextArea";
import { FC, useState } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Issue, IssuesForm } from "../../../../types/draw-request";
import { drawRequestsService } from "../../../../services/draw-request";

interface Props {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  drawRequestId?: number | string;
  // setEditingId: React.Dispatch<React.SetStateAction<string | number | undefined>>;
  // data: DrawRequestResp[];
  // setData: React.Dispatch<React.SetStateAction<DrawRequestResp[]>>;
  onDeny?: () => void;
}

/**========================================================================
/*                          external const here
/  *========================================================================**/

/*============================ END OF SECTION ============================*/

/**========================================================================
 *                           external methods here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

export const DenyDrawRequestModal: FC<Props> = ({
  visible,
  setVisible,
  drawRequestId,
  onDeny
  // setEditingId, data, setData
}) => {
  /**========================================================================
   *                           Hooks here
   *========================================================================**/
  const [form] = Form.useForm<IssuesForm>();
  const [issues, setIssues] = useState<Issue[]>([
    {
      id: 1,
      description: "",
      title: ""
    }
  ]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Const here
   *========================================================================**/
  const btns = [
    <Button key="cancel" onClick={() => closeModal()}>
      Cancel
    </Button>,

    <Button key="submit" type="primary" onClick={() => form.submit()}>
      submit
    </Button>
  ];
  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Methods here
   *========================================================================**/
  const closeModal = () => {
    setVisible(false);
    // setEditingId(undefined);
    form.resetFields();
    setIssues([
      {
        id: 1,
        description: "",
        title: ""
      }
    ]);
  };

  const handleForm = async () => {
    setIsLoading(true);

    try {
      const issuesData = [
        ...issues.map((is) => ({
          title: form.getFieldValue(`title${is.id}`) || "",
          description: form.getFieldValue(`description${is.id}`) || ""
        }))
      ];

      // const drawRequest =
      await drawRequestsService.denyDrawRequest(drawRequestId as number, [...issuesData]);

      // setData((old) => [...old.map((item) => (item.id === drawRequest?.id ? { ...drawRequest } : item))]);
      message.success(`Draw request denied`);
      if (onDeny) onDeny();
    } catch (error) {
      console.error(error);
      message.error(`Ups: something was wrong denying the draw request, please try again later or contact the support team`);
    }

    closeModal();
    setIsLoading(false);
  };

  const addNewIssue = () => {
    const id = Math.floor(Math.random() * 999999) * issues.length;
    setIssues((old) => [
      ...old,
      {
        id,
        description: "",
        title: ""
      }
    ]);
  };

  const deleteIssue = (id: number) => {
    setIssues((old) => [...old.filter((issue) => issue.id !== id)]);
  };

  /*============================ END OF SECTION ============================*/

  return (
    <>
      {/* /========================================================================  HTML here
    ========================================================================*/}
      <Spin spinning={isLoading} tip="Working on it..." size="large">
        <Modal title="Specify the issues you found" onCancel={closeModal} centered={true} visible={visible} footer={btns}>
          <div
            style={{
              maxHeight: "50vh",
              overflow: "auto",
              position: "relative"
            }}
          >
            <Button
              style={{ position: "absolute", top: 4, zIndex: 999 }}
              onClick={() => addNewIssue()}
              type="primary"
              shape="circle"
              icon={<PlusOutlined />}
              size="small"
            />

            <div
              style={{
                maxHeight: "50vh",
                overflow: "auto"
              }}
            >
              <Form scrollToFirstError={{ behavior: "auto" }} name="draw-request-form" form={form} onFinish={handleForm}>
                {issues.map((issue, index) => (
                  <div key={issue.id} style={{ marginTop: "33px" }}>
                    <Divider>Issue # {index + 1}</Divider>
                    {issues.length > 1 && (
                      <Row>
                        <Col
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: "10px"
                          }}
                          span={24}
                        >
                          <Button
                            danger
                            onClick={() => {
                              deleteIssue(issue.id);
                            }}
                            type="primary"
                            shape="circle"
                            icon={<DeleteOutlined />}
                            size="small"
                          />
                        </Col>
                      </Row>
                    )}
                    <Row>
                      <Col span={24}>
                        <FormItem
                          labelCol={{ span: 9 }}
                          labelAlign="left"
                          label="Title"
                          name={`title${issue.id}`}
                          rules={[{ required: true, message: "title is required" }]}
                        >
                          <Input placeholder="specify a title" />
                        </FormItem>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <FormItem
                          labelCol={{ span: 9 }}
                          labelAlign="left"
                          label="Description"
                          name={`description${issue.id}`}
                          rules={[{ required: true, message: "description is required" }]}
                        >
                          <TextArea placeholder="write a description" style={{ width: "100%", height: "100%" }} inputMode="text" />
                        </FormItem>
                      </Col>
                    </Row>
                  </div>
                ))}
              </Form>
            </div>
          </div>
        </Modal>
      </Spin>
      {/*============================ END OF SECTION ============================*/}
    </>
  );
};
